exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-sidebar{position:fixed;top:50px;left:0;bottom:0;padding:20px 0 50px;width:180px;min-width:45px;max-height:100vh;height:calc(100% - 50px);z-index:1023;background:#fff;box-shadow:0 2px 3px hsla(0,0%,7%,.1),0 0 0 1px hsla(0,0%,7%,.1);overflow-y:auto;overflow-x:hidden}@media screen and (max-width:768px){.app-sidebar{transform:translate3d(-180px,0,0)}}.app-sidebar .icon{vertical-align:baseline}.app-sidebar .icon.is-angle{position:absolute;right:10px;transition:transform .377s ease}.app-sidebar .menu-label{padding-left:5px}.app-sidebar .menu-list li a[aria-expanded=true] .is-angle{-ms-transform:rotate(180deg);transform:rotate(180deg)}.app-sidebar .menu-list li a+ul{margin:0 10px 0 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46700251","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Sidebar.vue
// module id = 35
// module chunks = 4